export const PAGE_TEXT: Record<string, string> = {
  TITLE:
    'Please check if your Online Verification Code(s) (在线验证码) is (are) valid until the\nend of your online programme registration period, please update accordingly.',
  INSTITUTION_NAME: 'Institution Name (学校名称)',
  DEGREE_LEVEL: 'Degree Level (学位级别)',
  ACADEMIC_CREDENTIAL:
    'Online Verification Code of Academic Credential (毕业证书)',
  DEGREE_CERTIFICATE:
    'Online Verification Code of Degree Certificate (学位证书)',
  SAVE_HINT:
    'Please enter your latest online verification and press “save" to update changes. If no updates requires, please press "Proceed to Programme Registration" during the online programme registration period as stated\nabove.',

  PASSED: 'Completed',
  NOT_PASSED: 'Not yet completed',
  ACADEMIC_CREDENTIAL_CHECK_NAME: 'Academic Credential',
  DEGREE_CERTIFICATE_CHECK_NAME: 'Degree Certificate',
};

export const studentStatusInformation = `
<p>As it takes time to verify your qualifications and confirm the authenticity of your transcripts/certificates/reports, please DO NOT enquire about the
verification status unless it still has not been updated 2 weeks before the commencement of the semester/term. A
notification email will be sent to you once all qualifications are verified. We will approach you in case you need to re-submit the
supporting documents for verification.</p>
<p><span class="important-note">If you have been given a conditional offer, you are reminded to complete the procedures in the Meeting Conditions section
even if you have arranged to send us documents for our verification. Otherwise, your conditional offer will become lapsed and
fees paid will not be refunded.</span></p>
`;
